import React from 'react';
import { observer } from 'mobx-react';
import SelectCustom from "../../../common/components/input/SelectCustom"

import CloseIcon from '@material-ui/icons/Close';
import { Icon, IconButton, CircularProgress, TextField } from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';

function InviteLink({ data, roles, onDelete, onUpdate }) {
    const [isLoading, setIsLoading] = React.useState(false);
    const role = roles.find(item => item.id == data.role_id);
    const url = window.appStore?.configStore?.config?.site?.server_url + "/invite/t/id/" + data.invite_id;
    const handleDelete = async () => {
        setIsLoading(true);
        await onDelete({ ...data, is_deleted: 1 })
        setIsLoading(false);
    };
    const handleUpdate = async (val) => {
        setIsLoading(true);
        await onUpdate({ ...data, role_id: val.id });
        setIsLoading(false);
    }
    if (!role) {
        return null;
    }

    return (
        <div>
            <div style={{
                display: "flex",
                alignItems: "center"
            }}>
                <LinkIcon /><b> {role.name} invite link for {data.type == "ANY_EMAIL" ? "any email" : "@" + data.domain} </b>
            </div>
            <div style={{
                display: "flex",
                justifyContent: "space-between",
                padding: 5,
                alignItems: "center"

            }}>
                <TextField
                    fullWidth
                    variant="outlined"
                    onClick={(ev) => {
                        ev.target.select();
                    }}
                    value={url}
                />
                <IconButton onClick={(ev) => {
                    navigator.clipboard.writeText(url);
                    Ext.Msg.alert("Success", "Invite link copied to clipboard")
                }}>
                    <Icon className="far fa-clone" color="primary" />
                </IconButton>
                <div style={{
                    display: "flex",
                    alignItems: "center"
                }}>
                    <SelectCustom
                        values={[...roles]}
                        disabled={data.is_owner || false}
                        valueKey={"id"}
                        displayKey={"name"}
                        style={{
                            marginLeft: 10
                        }}
                        value={role}
                        onChange={handleUpdate}
                        disabled={isLoading}
                        shouldForwardEvent={false}
                    />
                    {
                        !isLoading ?
                            <IconButton
                                style={{
                                    visibility: !data.is_owner ? "visible" : "hidden",
                                }}
                                onClick={handleDelete}>
                                <CloseIcon style={{
                                    fontSize: 12,
                                }} />
                            </IconButton>
                            :
                            <div style={{ width: 40, paddingLeft: 5 }}>
                                <CircularProgress size={20} />
                            </div>
                    }
                </div>
            </div>
        </div >
    );
}


export default observer(InviteLink);